import { noop } from 'libs';
import * as Filter from 'components/filters';

interface FiltersAsideProps {
  disableLenderFilter: boolean;
  filters: {
    amortization?: number | string;
    beacon?: number | string;
    gds?: number | string;
    insurable?: string;
    insurance?: string;
    lender_type?: string[];
    lenders?: (number | string)[];
    ltv?: number | string;
    mortgage_amount?: number | string;
    preferred?: 0 | 1 | '0' | '1';
    programs?: string[];
    property_value?: number | string;
    purchase?: 0 | 1 | '0' | '1';
    purpose?: string;
    rate_hold?: number | string;
    refinance?: 0 | 1 | '0' | '1';
    regions?: string;
    tds?: number | string;
    term_id?: string[];
    transfer?: 0 | 1 | '0' | '1';
    type?: string;
  };
  inputSize?: 'default' | 'lg';
  onClear?: () => void;
  onFilter?: () => void;
  showClearButton?: boolean;
}

const FiltersAside = ({
  disableLenderFilter,
  filters: {
    amortization,
    beacon,
    gds,
    insurable,
    insurance,
    lender_type,
    lenders,
    ltv,
    mortgage_amount,
    preferred,
    programs,
    property_value,
    purchase,
    purpose,
    rate_hold,
    refinance,
    regions,
    tds,
    term_id,
    transfer,
    type,
  },
  inputSize = 'default',
  onClear = noop,
  onFilter = noop,
  showClearButton = true,
}: FiltersAsideProps) => (
  <div className="sidebar z-2" id="filters">
    {showClearButton && <Filter.CurrentFilters onClear={onClear} />}
    <Filter.PreferredLenders filters={{ preferred }} isPro onFilter={onFilter} />
    <Filter.Region filters={{ regions }} isPro onFilter={onFilter} />
    <Filter.TransactionType filters={{ refinance, purchase, transfer }} onFilter={onFilter} />
    <Filter.PurposeAndRateType filters={{ purpose, programs }} isPro onFilter={onFilter} />
    <Filter.Program filters={{ programs }} isPro onFilter={onFilter} size={inputSize} />
    <Filter.ExclusiveRates filters={{ programs }} isPro onFilter={onFilter} />
    <Filter.TermType filters={{ type }} onFilter={onFilter} />
    <Filter.Term filters={{ term_id }} onFilter={onFilter} size={inputSize} />
    <Filter.Lender disabled={disableLenderFilter} filters={{ lenders }} onFilter={onFilter} />
    <Filter.LenderType filters={{ lender_type }} onFilter={onFilter} />
    <Filter.RateHold filters={{ rate_hold }} isPro onFilter={onFilter} />
    <Filter.Amortization filters={{ amortization }} onFilter={onFilter} />
    <Filter.LTVCalculation filters={{ ltv, mortgage_amount, property_value }} onFilter={onFilter} />
    <Filter.GdsTds filters={{ gds, tds }} isPro onFilter={onFilter} />
    <Filter.Beacon filters={{ beacon }} isPro onFilter={onFilter} />
    <Filter.Insurance filters={{ insurance, insurable }} isPro onFilter={onFilter} />
  </div>
);

export default FiltersAside;
